module.exports = __webpack_public_path__ + "img/mordred.c860d74e.png";